<app-search-menu
  [entries]="queryAllAttachments.bind(this)"
  (entrySelected)="selectAttachment($event)"
>
  <ng-content></ng-content>
</app-search-menu>
